<template>
  <div
    :id="`html-audio-${dynamicNumber}`"

    class="htmlAudio"
  >
    <!-- {{ audioFile }} -->
    <audio controls>

      <source
        :src="audioFile?.url"
        type="audio/mpeg"
      >
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>

import { nextTick } from "vue";
export default {
  props: {


    audioFile: {
      type:String,
      default:''
    },

  },

  data() {
    return {
      isShownBgVideo: false,
      videoWidth: 2500,
      videoHeight: 900,
      videoVimeoWidth: 2500,
      videoVimeoHeight: 1406,
      plus: 9,
      divide: 16,
    };
  },

  computed: {
    dynamicNumber() {
      const randomNum = Math.floor(1000 + Math.random() * 9000);
      return randomNum;
    },
  },



  mounted() {
    //
  },


};
</script>


<style lang="scss">
.htmlAudio {
  display: flex;
  width: 100%;
  audio {
    width: 100%;
  }
}
</style>
